import { type ContentfulPage } from '../hooks/useGraphQL'

export const getPagePathViaId = (
  id: string,
  fullPaths: ContentfulPage[],
): string | null => {
  const item = fullPaths.find(item => item.id === id)

  if (item) {
    return item.path === 'home' ? '/' : item.path
  }

  return null
}

export const getPageIdViaPath = (
  path: string,
  fullPaths: ContentfulPage[],
): string | null => {
  const item = fullPaths.find(item => item.path === path)

  return item?.id ?? null
}
